// 快捷键管理
export const hotkey = {
  name: "hotkey",
  state: {
    "shift+a": {
      activity: false
    },
    enter: {
      activity: false,
      // 暂停一次事件
      suspend: false
    },
    delete: {
      activity: false
    }
  },
  reducers: {
    // 获取localStorage 里面的配置信息
    updateHotKey(state, hotkeyInfo) {
      if (state.hasOwnProperty(hotkeyInfo.hotkey)) {
        state[hotkeyInfo.hotkey].activity = hotkeyInfo.activity;
        state[hotkeyInfo.hotkey].suspend = hotkeyInfo.suspend || false;
      }
      return { ...state };
    }
  }
};
